import React from 'react';
import styled from 'styled-components';

import useScreenQuery from '../../../../hooks/useScreenQuery';
import PlayupThemeProvider from '../../../../themes/PlayupThemeProvider';
import { PageContainer } from '../../sharedStyles';
import { TitleHeader } from '../../sharedStyledComponents';
import Modal from '../../../../components/Modal/Modal';
import Button from '../../../../components/Button/Button';
import AUContent from './AUContent';
import UsContent from './USContent';

const PortalCloseAccount = ({
	brandName,
	errorMessage,
	handleSubmit,
	isUS = false,
	responsibleGamblingUrl,
	sending = false,
	termsUrl,
	usState,
	usStateConfig,
}: PortalCloseAccountProps) => {
	const { isSmall } = useScreenQuery();
	const [showModal, setShowModal] = React.useState(false);

	return (
		<PlayupThemeProvider>
			{isSmall && <TitleHeader title={'Close Account'} />}
			<PageContainer isSmallScreen={isSmall}>
				{isUS ? (
					<UsContent
						usState={usState}
						brandName={brandName}
						isSmall={isSmall}
						showConfirm={() => setShowModal(true)}
						usStateConfig={usStateConfig}
						errorMessage={errorMessage}
					/>
				) : (
					<AUContent
						termsUrl={termsUrl}
						brandName={brandName}
						isSmall={isSmall}
						responsibleGamblingUrl={responsibleGamblingUrl}
						showConfirm={() => setShowModal(true)}
						errorMessage={errorMessage}
					/>
				)}
				{showModal && (
					<Modal onClose={() => setShowModal(false)} title="Confirm Close Account">
						<ModalText isSmallScreen={isSmall}>
							Please note that this is a firm commitment. You will NOT be able to login to this account.
						</ModalText>
						<Button isLoading={sending} kind="danger" height={50} onClick={handleSubmit}>
							Close Account
						</Button>
						<Button height={50} onClick={() => setShowModal(false)}>
							Cancel
						</Button>
					</Modal>
				)}
			</PageContainer>
		</PlayupThemeProvider>
	);
};
export default PortalCloseAccount;

export interface PortalCloseAccountProps {
	brandName: string;
	responsibleGamblingUrl: string;
	termsUrl: string;
	sending: boolean;
	errorMessage?: string;
	handleSubmit: () => void;
	isUS?: boolean;
	usState?: string;
	usStateConfig?: { [key: string]: any };
}

const ModalText = styled.p<{ isSmallScreen: boolean }>`
	text-align: center;
	margin-bottom: ${({ isSmallScreen }) => (isSmallScreen ? '20px' : '30px')};
	font-size: ${({ isSmallScreen }) => (isSmallScreen ? '14px' : '18px')};
`;
